
                import "css-modules://src_components_columns"
                export default {"Main":"_94eb90","Column":"_8bb261","Link":"_407384","Icon":"_0417d6"}
            